import { AfterContentChecked, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { CONTRACT_STATUS_ENUM, LOT_JOB_STATUS_ENUM } from '@classictechsolutions/hubapi-transpiled-enums';
import { take } from 'rxjs';
import { BaseSearchViewDirective } from '@app/shared/base-views/base-search-view.directive';
import { NavigationService } from '@app/core/services/navigation/navigation.service';
import { ProductLogicService } from '@app/logic/products';
import { TableComponent, USER_CACHE_AREA } from 'cb-hub-lib';
import { ToastService } from '@app/core/services/toast/toast.service';
import { UserCacheService } from '@app/core/services/user-cache/user-cache.service';

@Component({
    selector: 'cb-item-usage-confirmed-quantity-tab',
    templateUrl: './item-usage-confirmed-quantity.component.html',
    styleUrls: ['./item-usage-confirmed-quantity.component.scss'],
    standalone: false
})
export class ItemUsageConfirmedQuantityComponent extends BaseSearchViewDirective<any> implements OnInit, AfterContentChecked {
    @Input() public productId: number;
    public CONTRACT_STATUS_ENUM = CONTRACT_STATUS_ENUM;
    public LOT_JOB_STATUS_ENUM = LOT_JOB_STATUS_ENUM;
    @ViewChild('infiniteScrollTable', { static: false }) public infiniteScrollTable: TableComponent;

    public viewLot = (confirmedQuantity: any): void => {
        this.navigationService.navigate([`/lots/${confirmedQuantity.lotId}`], undefined);
    };

    constructor(
        public readonly navigationService: NavigationService,
        public readonly productLogicService: ProductLogicService,
        public readonly toastSerivce: ToastService,
        public readonly userCacheService: UserCacheService,
        private readonly cdref: ChangeDetectorRef) {

        super(
            productLogicService,
            toastSerivce,
            userCacheService,
            USER_CACHE_AREA.BuildActivitySearch,
        );
    }

    public ngOnInit(): void {
        this.loadSearchParams();
    }

    public ngAfterContentChecked(): void {
        this.cdref.detectChanges();
    }

    public doSearch = (): void => {
        if (this.shouldDoSearch()) {
            this.doSearchIfNoScrollBar();
            this.currentPage++;
            this.searchIsLoading = true;
            this.productLogicService
                .getProductConfirmedQuantityUsage(this.productId, {
                    currentPage: this.currentPage,
                    pageSize: this.pageSize
                }).pipe(take(1)).subscribe({
                    next: this.handleSearchResult,
                    error: this.handleSearchError
                });
        }
    };
}
